import React from 'react';

import {theme} from '../constants';

export const Assistance: React.FC = () => {
  return (
    <div style={{color: theme.colors.textColor}}>
      * need asistance? contact me via{' '}
      <a
        href='https://t.me/George_Kuliashvili'
        style={{
          color: theme.colors.mainColor, // Замените 'blue' на желаемый цвет
          textDecoration: 'none', // Убирает подчеркивание
          ...theme.fonts.Mulish_700Bold,
        }}
      >
        Telegram
      </a>
    </div>
  );
};
